import { useMemo } from 'react';
import { permissions } from './permissions';
import { Permission, OrgType, UserPermissionRole, AppTenant } from '@retail/auth/types';

export function usePermissionsForUserRoleAndType(
  role: UserPermissionRole,
  appTenant: AppTenant,
  roleType: OrgType
): Permission[] {
  return useMemo(
    () =>
      permissions
        .filter((perm) => perm.orgType === roleType)
        .filter((perm) => perm.userRole === role)
        .filter((perm) => perm.appTenants.includes(appTenant.countryCode)),
    [appTenant.countryCode, role, roleType]
  );
}
